// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.render-orders-container .upload-btn {
  padding: 6px 12px;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9em;
  transition: background-color 0.2s;
}
.render-orders-container .modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease-in-out;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.render-orders-container .modal-content {
  background-color: white;
  border-radius: 12px;
  width: 600px;
  max-width: 90%;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease-out;
}
.render-orders-container .modal-content .modal-header {
  padding: 20px 24px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.render-orders-container .modal-content .modal-header h3 {
  margin: 0;
  font-size: 1.25rem;
  color: #1f2937;
  font-weight: 600;
}
.render-orders-container .modal-content .modal-header .close-icon-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #6b7280;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.render-orders-container .modal-content .modal-header .close-icon-btn:hover {
  background-color: #f3f4f6;
  color: #1f2937;
}
.render-orders-container .modal-content .upload-section {
  padding: 24px;
  border-bottom: 1px solid #f3f4f6;
}
.render-orders-container .modal-content .upload-section .drag-drop-area {
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  padding: 30px 20px;
  text-align: center;
  transition: all 0.2s;
  background-color: #f9fafb;
  cursor: pointer;
}
.render-orders-container .modal-content .upload-section .drag-drop-area.active {
  border-color: var(--primary-color);
  background-color: #eff6ff;
}
.render-orders-container .modal-content .upload-section .drag-drop-area:hover {
  border-color: var(--primary-color);
  background-color: #f0f9ff;
}
.render-orders-container .modal-content .upload-section .drag-drop-area input[type=file] {
  display: none;
}
.render-orders-container .modal-content .upload-section .drag-drop-area .upload-label {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.render-orders-container .modal-content .upload-section .drag-drop-area .upload-label .upload-icon {
  color: var(--primary-color);
}
.render-orders-container .modal-content .upload-section .drag-drop-area .upload-label p {
  margin: 0;
  font-size: 1rem;
  color: #374151;
  font-weight: 500;
}
.render-orders-container .modal-content .upload-section .drag-drop-area .upload-label small {
  color: #6b7280;
  font-size: 0.85rem;
}
.render-orders-container .modal-content .upload-section .selected-file-info {
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f0f9ff;
  padding: 12px;
  border-radius: 6px;
  border: 1px solid #bae6fd;
}
.render-orders-container .modal-content .upload-section .selected-file-info .file-details {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #0369a1;
}
.render-orders-container .modal-content .upload-section .selected-file-info .file-details .file-icon {
  font-size: 1.2rem;
}
.render-orders-container .modal-content .upload-section .selected-file-info .file-details .file-name {
  font-weight: 500;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.render-orders-container .modal-content .upload-section .selected-file-info .file-details .file-size {
  font-size: 0.85rem;
  color: #0c4a6e;
}
.render-orders-container .modal-content .upload-section .selected-file-info .upload-submit-btn {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.9rem;
  transition: background-color 0.2s;
}
.render-orders-container .modal-content .upload-section .selected-file-info .upload-submit-btn:hover:not(:disabled) {
  background-color: var(--primary-color-dark);
}
.render-orders-container .modal-content .upload-section .selected-file-info .upload-submit-btn:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}
.render-orders-container .modal-content .upload-section .progress-bar-container {
  margin-top: 12px;
  height: 6px;
  background-color: #e5e7eb;
  border-radius: 3px;
  overflow: hidden;
}
.render-orders-container .modal-content .upload-section .progress-bar-container .progress-bar-fill {
  height: 100%;
  background-color: var(--primary-color);
  transition: width 0.3s ease;
}
.render-orders-container .modal-content .uploaded-orders-list {
  padding: 24px;
  flex: 1 1;
}
.render-orders-container .modal-content .uploaded-orders-list h4 {
  margin: 0 0 16px 0;
  font-size: 1rem;
  color: #374151;
  font-weight: 600;
}
.render-orders-container .modal-content .uploaded-orders-list .no-docs-message {
  text-align: center;
  padding: 20px;
  color: #6b7280;
  background-color: #f9fafb;
  border-radius: 6px;
  border: 1px dashed #e5e7eb;
}
.render-orders-container .modal-content .uploaded-orders-list .docs-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.render-orders-container .modal-content .uploaded-orders-list .order-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background-color: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  transition: all 0.2s;
}
.render-orders-container .modal-content .uploaded-orders-list .order-item:hover {
  border-color: #d1d5db;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.render-orders-container .modal-content .uploaded-orders-list .order-item .doc-info {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #374151;
  font-weight: 500;
}
.render-orders-container .modal-content .uploaded-orders-list .order-item .doc-info .doc-icon {
  color: #6b7280;
  font-size: 1.1rem;
}
.render-orders-container .modal-content .uploaded-orders-list .order-item .doc-info .upload-date {
  font-size: 0.8rem;
  color: #9ca3af;
  font-weight: normal;
  margin-left: 4px;
}
.render-orders-container .modal-content .uploaded-orders-list .order-item .order-actions {
  display: flex;
  gap: 8px;
}
.render-orders-container .modal-content .uploaded-orders-list .order-item .order-actions button {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  font-size: 0.85rem;
  font-weight: 500;
  transition: all 0.2s;
}
.render-orders-container .modal-content .uploaded-orders-list .order-item .order-actions button.view-btn {
  background-color: #eff6ff;
  color: #2563eb;
}
.render-orders-container .modal-content .uploaded-orders-list .order-item .order-actions button.view-btn:hover {
  background-color: #dbeafe;
}
.render-orders-container .modal-content .uploaded-orders-list .order-item .order-actions button.delete-btn {
  background-color: #fef2f2;
  color: #dc2626;
}
.render-orders-container .modal-content .uploaded-orders-list .order-item .order-actions button.delete-btn:hover {
  background-color: #fee2e2;
}

@keyframes slideUp {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/TabViewer/RenderOrders.scss"],"names":[],"mappings":"AACE;EACE,iBAAA;EACA,sCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iCAAA;AAAJ;AAOE;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kCAAA;AALJ;AAQE;EACE;IAAO,UAAA;EALT;EAME;IAAK,UAAA;EAHP;AACF;AAKE;EACE,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;EACA,aAAA;EACA,sBAAA;EACA,gCAAA;AAHJ;AAKI;EACE,kBAAA;EACA,gCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAHN;AAKM;EACE,SAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;AAHR;AAMM;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAJR;AAMQ;EACE,yBAAA;EACA,cAAA;AAJV;AASI;EACE,aAAA;EACA,gCAAA;AAPN;AASM;EACE,0BAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,yBAAA;EACA,eAAA;AAPR;AASQ;EACE,kCAAA;EACA,yBAAA;AAPV;AAUQ;EACE,kCAAA;EACA,yBAAA;AARV;AAWQ;EACE,aAAA;AATV;AAYQ;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;AAVV;AAYU;EACE,2BAAA;AAVZ;AAaU;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAXZ;AAcU;EACE,cAAA;EACA,kBAAA;AAZZ;AAiBM;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;AAfR;AAiBQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;AAfV;AAiBU;EACE,iBAAA;AAfZ;AAkBU;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAhBZ;AAmBU;EACE,kBAAA;EACA,cAAA;AAjBZ;AAqBQ;EACE,sCAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iCAAA;AAnBV;AAqBU;EACE,2CAAA;AAnBZ;AAsBU;EACE,yBAAA;EACA,mBAAA;AApBZ;AAyBM;EACE,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAvBR;AAyBQ;EACE,YAAA;EACA,sCAAA;EACA,2BAAA;AAvBV;AA4BI;EACE,aAAA;EACA,SAAA;AA1BN;AA4BM;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA1BR;AA6BM;EACE,kBAAA;EACA,aAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,0BAAA;AA3BR;AA8BM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA5BR;AA+BM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,oBAAA;AA7BR;AA+BQ;EACE,qBAAA;EACA,yCAAA;AA7BV;AAgCQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;AA9BV;AAgCU;EACE,cAAA;EACA,iBAAA;AA9BZ;AAiCU;EACE,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AA/BZ;AAmCQ;EACE,aAAA;EACA,QAAA;AAjCV;AAmCU;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;AAjCZ;AAmCY;EACE,yBAAA;EACA,cAAA;AAjCd;AAmCc;EACE,yBAAA;AAjChB;AAqCY;EACE,yBAAA;EACA,cAAA;AAnCd;AAqCc;EACE,yBAAA;AAnChB;;AA6CA;EACE;IACE,2BAAA;IACA,UAAA;EA1CF;EA4CA;IACE,wBAAA;IACA,UAAA;EA1CF;AACF","sourcesContent":[".render-orders-container {\r\n  .upload-btn {\r\n    padding: 6px 12px;\r\n    background-color: var(--primary-color);\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-size: 0.9em;\r\n    transition: background-color 0.2s;\r\n\r\n    // &:hover {\r\n    //   background-color: var(--primary-color-dark);\r\n    // }\r\n  }\r\n\r\n  .modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 1000;\r\n    animation: fadeIn 0.2s ease-in-out;\r\n  }\r\n\r\n  @keyframes fadeIn {\r\n    from { opacity: 0; }\r\n    to { opacity: 1; }\r\n  }\r\n\r\n  .modal-content {\r\n    background-color: white;\r\n    border-radius: 12px;\r\n    width: 600px;\r\n    max-width: 90%;\r\n    max-height: 85vh;\r\n    overflow-y: auto;\r\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);\r\n    display: flex;\r\n    flex-direction: column;\r\n    animation: slideUp 0.3s ease-out;\r\n\r\n    .modal-header {\r\n      padding: 20px 24px;\r\n      border-bottom: 1px solid #e5e7eb;\r\n      display: flex;\r\n      justify-content: space-between;\r\n      align-items: center;\r\n\r\n      h3 {\r\n        margin: 0;\r\n        font-size: 1.25rem;\r\n        color: #1f2937;\r\n        font-weight: 600;\r\n      }\r\n\r\n      .close-icon-btn {\r\n        background: none;\r\n        border: none;\r\n        cursor: pointer;\r\n        padding: 4px;\r\n        color: #6b7280;\r\n        border-radius: 4px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n\r\n        &:hover {\r\n          background-color: #f3f4f6;\r\n          color: #1f2937;\r\n        }\r\n      }\r\n    }\r\n\r\n    .upload-section {\r\n      padding: 24px;\r\n      border-bottom: 1px solid #f3f4f6;\r\n\r\n      .drag-drop-area {\r\n        border: 2px dashed #d1d5db;\r\n        border-radius: 8px;\r\n        padding: 30px 20px;\r\n        text-align: center;\r\n        transition: all 0.2s;\r\n        background-color: #f9fafb;\r\n        cursor: pointer;\r\n\r\n        &.active {\r\n          border-color: var(--primary-color);\r\n          background-color: #eff6ff;\r\n        }\r\n\r\n        &:hover {\r\n          border-color: var(--primary-color);\r\n          background-color: #f0f9ff;\r\n        }\r\n\r\n        input[type=\"file\"] {\r\n          display: none;\r\n        }\r\n\r\n        .upload-label {\r\n          cursor: pointer;\r\n          display: flex;\r\n          flex-direction: column;\r\n          align-items: center;\r\n          gap: 10px;\r\n\r\n          .upload-icon {\r\n            color: var(--primary-color);\r\n          }\r\n\r\n          p {\r\n            margin: 0;\r\n            font-size: 1rem;\r\n            color: #374151;\r\n            font-weight: 500;\r\n          }\r\n\r\n          small {\r\n            color: #6b7280;\r\n            font-size: 0.85rem;\r\n          }\r\n        }\r\n      }\r\n\r\n      .selected-file-info {\r\n        margin-top: 16px;\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        background-color: #f0f9ff;\r\n        padding: 12px;\r\n        border-radius: 6px;\r\n        border: 1px solid #bae6fd;\r\n\r\n        .file-details {\r\n          display: flex;\r\n          align-items: center;\r\n          gap: 8px;\r\n          color: #0369a1;\r\n\r\n          .file-icon {\r\n            font-size: 1.2rem;\r\n          }\r\n\r\n          .file-name {\r\n            font-weight: 500;\r\n            max-width: 200px;\r\n            white-space: nowrap;\r\n            overflow: hidden;\r\n            text-overflow: ellipsis;\r\n          }\r\n\r\n          .file-size {\r\n            font-size: 0.85rem;\r\n            color: #0c4a6e;\r\n          }\r\n        }\r\n\r\n        .upload-submit-btn {\r\n          background-color: var(--primary-color);\r\n          color: white;\r\n          border: none;\r\n          padding: 8px 16px;\r\n          border-radius: 4px;\r\n          cursor: pointer;\r\n          font-weight: 500;\r\n          font-size: 0.9rem;\r\n          transition: background-color 0.2s;\r\n\r\n          &:hover:not(:disabled) {\r\n            background-color: var(--primary-color-dark);\r\n          }\r\n\r\n          &:disabled {\r\n            background-color: #9ca3af;\r\n            cursor: not-allowed;\r\n          }\r\n        }\r\n      }\r\n\r\n      .progress-bar-container {\r\n        margin-top: 12px;\r\n        height: 6px;\r\n        background-color: #e5e7eb;\r\n        border-radius: 3px;\r\n        overflow: hidden;\r\n\r\n        .progress-bar-fill {\r\n          height: 100%;\r\n          background-color: var(--primary-color);\r\n          transition: width 0.3s ease;\r\n        }\r\n      }\r\n    }\r\n\r\n    .uploaded-orders-list {\r\n      padding: 24px;\r\n      flex: 1;\r\n\r\n      h4 {\r\n        margin: 0 0 16px 0;\r\n        font-size: 1rem;\r\n        color: #374151;\r\n        font-weight: 600;\r\n      }\r\n\r\n      .no-docs-message {\r\n        text-align: center;\r\n        padding: 20px;\r\n        color: #6b7280;\r\n        background-color: #f9fafb;\r\n        border-radius: 6px;\r\n        border: 1px dashed #e5e7eb;\r\n      }\r\n\r\n      .docs-list {\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 10px;\r\n      }\r\n\r\n      .order-item {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        padding: 12px;\r\n        background-color: white;\r\n        border: 1px solid #e5e7eb;\r\n        border-radius: 6px;\r\n        transition: all 0.2s;\r\n\r\n        &:hover {\r\n          border-color: #d1d5db;\r\n          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\r\n        }\r\n\r\n        .doc-info {\r\n          display: flex;\r\n          align-items: center;\r\n          gap: 10px;\r\n          color: #374151;\r\n          font-weight: 500;\r\n\r\n          .doc-icon {\r\n            color: #6b7280;\r\n            font-size: 1.1rem;\r\n          }\r\n\r\n          .upload-date {\r\n            font-size: 0.8rem;\r\n            color: #9ca3af;\r\n            font-weight: normal;\r\n            margin-left: 4px;\r\n          }\r\n        }\r\n\r\n        .order-actions {\r\n          display: flex;\r\n          gap: 8px;\r\n\r\n          button {\r\n            display: flex;\r\n            align-items: center;\r\n            gap: 4px;\r\n            padding: 6px 10px;\r\n            border-radius: 4px;\r\n            border: none;\r\n            cursor: pointer;\r\n            font-size: 0.85rem;\r\n            font-weight: 500;\r\n            transition: all 0.2s;\r\n\r\n            &.view-btn {\r\n              background-color: #eff6ff;\r\n              color: #2563eb;\r\n\r\n              &:hover {\r\n                background-color: #dbeafe;\r\n              }\r\n            }\r\n\r\n            &.delete-btn {\r\n              background-color: #fef2f2;\r\n              color: #dc2626;\r\n\r\n              &:hover {\r\n                background-color: #fee2e2;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@keyframes slideUp {\r\n  from {\r\n    transform: translateY(20px);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateY(0);\r\n    opacity: 1;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
